var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67065 1.51774L0.205867 14.4462C0.0710267 14.6796 2.49561e-05 14.9445 6.57757e-09 15.2141C-2.49429e-05 15.4837 0.0709278 15.7486 0.205725 15.9821C0.340522 16.2156 0.534413 16.4095 0.767905 16.5443C1.0014 16.6791 1.26626 16.75 1.53587 16.75H16.4642C16.7338 16.75 16.9987 16.6791 17.2322 16.5443C17.4657 16.4095 17.6596 16.2156 17.7944 15.9821C17.9292 15.7486 18.0001 15.4837 18.0001 15.2141C18.0001 14.9445 17.9291 14.6796 17.7942 14.4462L10.3303 1.51774C10.1955 1.28432 10.0016 1.09048 9.76821 0.955716C9.53478 0.820949 9.26999 0.75 9.00045 0.75C8.73091 0.75 8.46612 0.820949 8.23269 0.955716C7.99926 1.09048 7.80542 1.28432 7.67065 1.51774Z",
    fill: "#E42125"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09783 5.50513H8.9031C8.4237 5.50513 8.03506 5.89376 8.03506 6.37317V10.5222C8.03506 11.0017 8.4237 11.3903 8.9031 11.3903H9.09783C9.57723 11.3903 9.96587 11.0017 9.96587 10.5222V6.37317C9.96587 5.89376 9.57723 5.50513 9.09783 5.50513Z",
    fill: "#FFFCF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00037 14.681C9.53355 14.681 9.96577 14.2488 9.96577 13.7156C9.96577 13.1825 9.53355 12.7502 9.00037 12.7502C8.4672 12.7502 8.03497 13.1825 8.03497 13.7156C8.03497 14.2488 8.4672 14.681 9.00037 14.681Z",
    fill: "#FFFCF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorExclamation);
export default __webpack_public_path__ + "static/media/ErrorExclamation.9a568a4d76b23f38efb0488256c17e6e.svg";
export { ForwardRef as ReactComponent };